import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 68322 68724"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528321688736">
        <path
          d="M34157 55199c-356 0-643-287-643-642v-8609c0-357 287-643 643-643 357 0 643 286 643 643v8609c0 355-286 642-643 642zM34157 10637c-356 0-643-286-643-643V643c0-357 287-643 643-643 357 0 643 286 643 643v9351c0 357-286 643-643 643z"
          className="fil0"
        />
        <path
          d="M36519 27723c-101 0-203-23-295-70-1207-626-2903-626-4119 0-271 140-596 70-789-161-2640-3167-7077-10870-7130-26849 0-171 69-334 186-457 123-124 286-186 456-186h18666c170 0 333 70 457 186 123 123 185 286 185 457-47 15971-4490 23674-7130 26849-124 154-302 231-487 231zm-2362-1834c759 0 1502 139 2168 402 2516-3205 6364-10474 6518-25005H25470c156 14522 4003 21800 6519 25005 674-263 1410-402 2168-402z"
          className="fil0"
        />
        <path
          d="M37439 28381c-169 0-332-62-456-193-627-635-1680-1014-2818-1014-1146 0-2199 379-2818 1014-209 209-526 256-782 108-5288-3073-14167-10761-14268-27646 0-170 61-333 186-457 123-123 286-193 456-193h34451c171 0 334 70 457 194 116 123 186 286 186 457-101 16885-8981 24572-14268 27645-101 63-217 85-326 85zM17582 1286c301 15383 8206 22613 13222 25663 868-673 2075-1060 3353-1060 1277 0 2493 387 3352 1060 5017-3042 12921-10280 13223-25663H17582zM30425 55749c-1455 0-3026-279-4188-1231-179-147-263-372-232-596 93-573 2261-14059 6062-22335 131-287 448-434 759-349 851 248 1803 248 2655 0 302-93 627 62 759 349 3801 8283 5977 21770 6062 22335 38 224-55 457-225 596-2508 2052-6945 975-7928 705-519 154-2036 526-3724 526zm3732-1835c232 46 4490 1324 6821-178-379-2246-2431-13750-5683-21136-743 140-1533 140-2276 0-3251 7386-5303 18891-5682 21136 2329 1502 6587 224 6634 209 62-23 124-31 186-31z"
          className="fil0"
        />
        <path
          d="M34157 32701c-2585 0-4614-1493-4614-3406s2029-3406 4614-3406c2586 0 4614 1493 4614 3406 0 1912-2021 3406-4614 3406zm0-5527c-1804 0-3329 967-3329 2121s1525 2121 3329 2121 3329-967 3329-2121c0-1146-1517-2121-3329-2121z"
          className="fil0"
        />
        <path
          d="M58900 61044H9429c-355 0-642-286-642-643V704c0-355 287-642 642-642h49471c356 0 642 287 642 642v59697c-7 357-294 643-642 643zm-48836-1285h48185V1347H10064v58412z"
          className="fil0"
        />
        <path
          d="M62957 61044H5373c-356 0-642-286-642-643V704c0-355 286-642 642-642h57584c356 0 642 287 642 642v59697c0 357-294 643-642 643zM6007 59759h56307V1347H6007v58412z"
          className="fil0"
        />
        <path
          d="M63839 68724H4482C2013 68724 0 66712 0 64242s2013-4484 4482-4484l59357 1c2477 0 4483 2013 4483 4483s-2014 4482-4483 4482zM4482 61044c-1764 0-3196 1432-3196 3198 0 1765 1432 3197 3196 3197h59357c1765 0 3198-1433 3198-3197 0-1766-1433-3198-3198-3198H4482z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
